const MASK_CHARS = 11;

// Masked key string: the first 11 characters.
export function maskKeyString(key: string): string {
  return `${key.slice(0, MASK_CHARS)}…`;
}

// Masked key for lists and labels, from the stored prefix and format.
export function maskApiKey(key: { api_key_prefix: string; api_key_format: string }): string {
  return maskKeyString(key.api_key_format === 'alck' ? `alck_${key.api_key_prefix}` : key.api_key_prefix);
}

// Table cell and title: the key name, or the masked key when the key has no name.
export function apiKeyName(key: { api_key_name: string; api_key_prefix: string; api_key_format: string }): string {
  return key.api_key_name || maskApiKey(key);
}

// Filter option label: the name with the masked key, or the masked key alone.
export function apiKeyLabel(key: { name: string; api_key_prefix: string; api_key_format: string }): string {
  const maskedKey = maskApiKey(key);
  return key.name ? `${key.name} (${maskedKey})` : maskedKey;
}
